import {inject, injectable} from 'inversify';

import {EnvProviderService} from '../env/EnvProvider.service';
import {RemoteFileStorageToken} from './RemoteFileStorageToken';
import {RemoteFileStorageUrl} from './RemoteFileStorageUrl';

@injectable()
export class RemoteFileStorageService {
  token = new RemoteFileStorageToken(this);
  url = new RemoteFileStorageUrl(this);

  constructor(
    @inject(EnvProviderService) private envProviderService: EnvProviderService,
  ) {}

  _shouldRunGuard() {
    return !this.envProviderService.app.isB2b;
  }
}
